import { render, staticRenderFns } from "./DepartmentModal.vue?vue&type=template&id=dd793fd2&scoped=true"
import script from "./DepartmentModal.vue?vue&type=script&lang=js"
export * from "./DepartmentModal.vue?vue&type=script&lang=js"
import style0 from "./DepartmentModal.vue?vue&type=style&index=0&id=dd793fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd793fd2",
  null
  
)

export default component.exports